(function () {
  const STORAGE_KEY = 'crr_decadence_popup_dismissed';

  const TEN = new Path2D();
  TEN.addPath(new Path2D('M31.2,43l-22.8,5L0,13.4,41.8,2h35.4v141H31.2V43Z'));
  TEN.addPath(
    new Path2D(
      'M91.6,73.4v-.4C91.6,34.4,116.8,0,159.2,0s67.2,34,67.2,72.6v.4c0,38.6-25.2,73-67.6,73s-67.2-34-67.2-72.6ZM180,73.4v-.4c0-19.2-8.6-32.4-21.2-32.4s-20.8,12.8-20.8,32v.4c0,19.2,8.6,32.4,21.2,32.4s20.8-12.8,20.8-32Z'
    )
  );
  const BOX = { x: 0, y: 0, w: 226.4, h: 146 };

  const SPEED = 0.35;
  const TILE = 12;
  const SPARK = 0.6;
  const REFL = 0.35;
  const TS = 0.3;
  const L = normalize([-0.5, -0.6, 0.62]);

  function normalize(v) {
    const m = Math.hypot(v[0], v[1], v[2]);
    return v.map((x) => x / m);
  }

  function readConfig(root) {
    const d = root.dataset;
    return {
      delayMs: Math.max(0, (parseInt(d.delaySeconds, 10) || 5) * 1000),
      scrollDepth: Math.max(0, Math.min(100, parseInt(d.scrollDepth, 10) || 0)),
      exitIntent: d.exitIntent === 'true',
      cookieDays: Math.max(1, parseInt(d.cookieDays, 10) || 7),
      homepageOnly: d.homepageOnly !== 'false',
    };
  }

  function isDismissed(days) {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const ts = parseInt(raw, 10);
      if (Number.isNaN(ts)) return false;
      return Date.now() - ts < days * 86400000;
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* ignore */
    }
  }

  function initRoot(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const cfg = readConfig(root);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (cfg.homepageOnly && root.dataset.template !== 'index') return;
    if (isDismissed(cfg.cookieDays)) return;

    const overlay = root;
    const dialog = root.querySelector('.decadence-popup');
    const closeBtn = root.querySelector('.decadence-popup__close');
    const cta = root.querySelector('.decadence-popup__cta');
    const cv = root.querySelector('[data-disco-canvas]');
    const rc = root.querySelector('[data-reflections-canvas]');

    if (!dialog || !cv || !rc) return;

    const ctx = cv.getContext('2d');
    const rctx = rc.getContext('2d');

    let W = 0;
    let H = 0;
    let dpr = 1;
    let tiles = [];
    let RW = 0;
    let RH = 0;
    let spots = [];
    let animating = false;
    let rafId = 0;
    let t0 = 0;
    let opened = false;
    let triggered = false;

    function buildTiles() {
      tiles = [];
      const R = Math.max(W, H) * 0.62;
      const rows = Math.max(8, Math.round((Math.PI * R) / TILE));
      for (let i = 0; i < rows; i++) {
        const lat = -Math.PI / 2 + (i + 0.5) * (Math.PI / rows);
        const cols = Math.max(4, Math.round((2 * Math.PI * R * Math.cos(lat)) / TILE));
        for (let j = 0; j < cols; j++) {
          tiles.push({
            lat,
            lon: (j * 2 * Math.PI) / cols,
            dLat: Math.PI / rows,
            dLon: (2 * Math.PI) / cols,
            tone: 0.35 + Math.random() * 0.35,
            seed: Math.random() * 1000,
          });
        }
      }
      tiles.R = R;
    }

    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      let r = cv.getBoundingClientRect();
      W = r.width;
      H = r.height;
      cv.width = W * dpr;
      cv.height = H * dpr;
      buildTiles();

      r = rc.getBoundingClientRect();
      RW = r.width;
      RH = r.height;
      rc.width = RW * dpr;
      rc.height = RH * dpr;
      spots = Array.from({ length: 26 }, () => ({
        x: Math.random(),
        y: Math.random(),
        r: 2 + Math.random() * 4,
        v: 0.4 + Math.random() * 0.6,
      }));
    }

    function disco(t) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      const R = tiles.R;
      const cx = W / 2;
      const cy = H / 2;
      const rot = t * SPEED * 0.6;
      for (const tl of tiles) {
        const lon = tl.lon + rot;
        const nz = Math.cos(tl.lat) * Math.cos(lon);
        if (nz <= 0.02) continue;
        const nx = Math.cos(tl.lat) * Math.sin(lon);
        const ny = Math.sin(tl.lat);
        const x = cx + R * nx;
        const y = cy + R * ny;
        const w = R * tl.dLon * Math.cos(tl.lat) * Math.cos(lon) * 0.9;
        const h = R * tl.dLat * Math.cos(tl.lat) * 0.9 + R * tl.dLat * 0.1;
        const diff = Math.max(0, nx * L[0] + ny * L[1] + nz * L[2]);
        const spec = Math.pow(diff, 28);
        const tw = SPARK * Math.pow(Math.max(0, Math.sin(t * 1.3 + tl.seed)), 60);
        const v = Math.min(1, tl.tone * (0.35 + 0.65 * diff) + spec * 1.1 + tw);
        const c = Math.round(60 + v * 195);
        ctx.fillStyle = `rgb(${c},${c + (v > 0.85 ? 0 : 3)},${Math.min(255, c + 8)})`;
        ctx.fillRect(x - w / 2, y - h / 2, Math.max(0.5, w), Math.max(0.5, h));
      }
      const k = Math.min((W * 0.96) / BOX.w, (H * 0.92) / BOX.h);
      ctx.save();
      ctx.translate(cx - (BOX.x + BOX.w / 2) * k, cy - (BOX.y + BOX.h / 2) * k);
      ctx.scale(k, k);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.fill(TEN);
      ctx.globalCompositeOperation = 'source-over';
      ctx.lineWidth = 1 / k;
      ctx.strokeStyle = 'rgba(255,255,255,.18)';
      ctx.stroke(TEN);
      ctx.restore();
    }

    function refl(t) {
      rctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      rctx.clearRect(0, 0, RW, RH);
      if (reduceMotion) return;
      const d = t * SPEED * 0.03;
      for (const s of spots) {
        const x = (((s.x + d * s.v) % 1) + 1) % 1 * RW;
        const y = s.y * RH;
        const g = rctx.createRadialGradient(x, y, 0, x, y, s.r * 3);
        g.addColorStop(0, `rgba(255,255,255,${0.5 * REFL})`);
        g.addColorStop(1, 'rgba(255,255,255,0)');
        rctx.fillStyle = g;
        rctx.beginPath();
        rctx.arc(x, y, s.r * 3, 0, 7);
        rctx.fill();
      }
    }

    function loop(n) {
      if (!animating) return;
      const rt = (n - t0) / 1000;
      disco(rt * TS);
      refl(rt);
      rafId = requestAnimationFrame(loop);
    }

    function startAnim() {
      if (animating) return;
      size();
      animating = true;
      t0 = performance.now();
      if (reduceMotion) {
        disco(2);
      } else {
        rafId = requestAnimationFrame(loop);
      }
    }

    function stopAnim() {
      animating = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
    }

    function openPopup() {
      if (opened) return;
      opened = true;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('decadence-popup-open');
      startAnim();
      closeBtn && closeBtn.focus();
    }

    function closePopup(persist) {
      if (!opened) return;
      opened = false;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('decadence-popup-open');
      stopAnim();
      if (persist !== false) setDismissed();
    }

    function tryTrigger() {
      if (triggered || opened) return;
      triggered = true;
      openPopup();
    }

    function scheduleTriggers() {
      if (cfg.delayMs > 0) {
        window.setTimeout(tryTrigger, cfg.delayMs);
      }

      if (cfg.scrollDepth > 0) {
        function onScroll() {
          const doc = document.documentElement;
          const max = doc.scrollHeight - window.innerHeight;
          if (max <= 0) return;
          const pct = (window.scrollY / max) * 100;
          if (pct >= cfg.scrollDepth) {
            window.removeEventListener('scroll', onScroll);
            tryTrigger();
          }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      if (cfg.exitIntent && window.matchMedia('(hover: hover)').matches) {
        const onLeave = (e) => {
          if (e.clientY > 0) return;
          document.removeEventListener('mouseout', onLeave);
          tryTrigger();
        };
        document.addEventListener('mouseout', onLeave);
      }

      if (cfg.delayMs === 0 && cfg.scrollDepth === 0 && !cfg.exitIntent) {
        tryTrigger();
      }
    }

    closeBtn &&
      closeBtn.addEventListener('click', () => {
        closePopup(true);
      });

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePopup(true);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && opened) closePopup(true);
    });

    if (cta) {
      cta.addEventListener('click', () => {
        setDismissed();
      });
    }

    window.addEventListener('resize', () => {
      if (opened) size();
    });

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((en) => en.isIntersecting);
        if (visible && opened) startAnim();
        else stopAnim();
      },
      { threshold: 0.05 }
    );
    io.observe(overlay);

    scheduleTriggers();
  }

  function boot() {
    document.querySelectorAll('[data-decadence-popup]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
